import React, { useEffect } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import FormModal from '../../Modals/FormModal';
import InputField from '../../Forms/Input/InputField';

interface ProductUnitPopupProps {
  popupOpen: boolean;
  setPopupOpen: (open: boolean) => void;
  onRegister: (unitData: {
    id: number,
    name: string;
    unitCode: string;
    mhCode: number;
  }) => void;
}

const ProductUnitPopup: React.FC<ProductUnitPopupProps> = ({
  popupOpen,
  setPopupOpen,
  onRegister,
}) => {
  // ✅ Validación Yup
  const validationSchema = Yup.object({
    name: Yup.string()
      .min(2, 'Debe tener al menos 2 caracteres')
      .required('El nombre es obligatorio'),

    unitCode: Yup.string()
      .min(1, 'Debe tener al menos 1 carácter')
      .max(10, 'Máximo 10 caracteres')
      .required('El código de unidad es obligatorio'),

    mhCode: Yup.number()
      .typeError('Debe ser un número')
      .required('El código MH es obligatorio')
      .min(1, 'Debe ser mayor a 0'),
  });

  // ✅ Formik
  const formik = useFormik({
    initialValues: {
      id: 0,
      name: '',
      unitCode: '',
      mhCode: '',
    },
    validationSchema,
    onSubmit: (values, { resetForm }) => {
      onRegister({
        id: values.id,
        name: values.name,
        unitCode: values.unitCode,
        mhCode: Number(values.mhCode),
      });
      resetForm();
      setPopupOpen(false);
    },
  });

  // 📌 Reset cuando se cierre
  useEffect(() => {
    if (!popupOpen) {
      formik.resetForm();
    }
  }, [popupOpen]);

  return (
    <FormModal
      isOpen={popupOpen}
      onClose={() => setPopupOpen(false)}
      title="Agregar Unidad de Medida"
      maxWidth="max-w-md"
    >
      <form onSubmit={formik.handleSubmit} className="mt-4">
        {/* Nombre */}
        <InputField
          label="Nombre"
          name="name"
          type="text"
          iconKey="edit"
          placeholder="Ej: Kilogramo, Litro, Metro"
          value={formik.values.name}
          onChange={formik.handleChange}
          error={
            formik.touched.name && formik.errors.name
              ? formik.errors.name
              : undefined
          }
        />

        {/* Código Interno */}
        <InputField
          label="Código de Unidad"
          name="unitCode"
          type="text"
          iconKey="edit"
          placeholder="Ej: KG, LT, MT"
          value={formik.values.unitCode}
          onChange={formik.handleChange}
          error={
            formik.touched.unitCode && formik.errors.unitCode
              ? formik.errors.unitCode
              : undefined
          }
        />

        {/* Código MH */}
        <InputField
          label="Código MH"
          name="mhCode"
          type="number"
          iconKey="hash"
          placeholder="Ej: 59, 03, 41"
          value={formik.values.mhCode}
          onChange={formik.handleChange}
          min={0}
          error={
            formik.touched.mhCode && formik.errors.mhCode
              ? formik.errors.mhCode
              : undefined
          }
        />

        <button
          type="submit"
          className="mt-4 w-full rounded bg-primary px-4 py-2 font-medium text-white hover:bg-opacity-90"
        >
          Guardar Unidad de Medida
        </button>
      </form>
    </FormModal>
  );
};

export default ProductUnitPopup;
